import Login from "../../../pages/login/Login";
import Contact from "../../../pages/Contact";
import Home from "../../../pages/Home";
import {
	getPXLContactRoute,
	getPXLDashboardRoute,
	getPXLJoinRoute,
	getPXLLoginRoute,
	getPXLPwdForget
} from './factory/general';
import PasswordForgotten from '../../../pages/PasswordForgotten';
import Join from '../../../pages/join/Join';

/**
 * React Router v7 doesn't use 'exact' prop anymore.
 * Routes by default match 'exactly' unless there is a * or a splat parameter in the path.
 * For more details, see the React Router v7 documentation.
 */
const routes = [
    {
        path: getPXLDashboardRoute(),
        component: Home,
        type: 'route',
        loginRequired: true,
    },
    {
        path: getPXLLoginRoute(),
        component: Login,
        type: 'route',
    },
    {
        path: getPXLJoinRoute(),
        component: Join,
        type: 'route',
        loginRequired: true,
    },
    {
        path: getPXLPwdForget(),
        component: PasswordForgotten,
        type: 'route',
    },
    {
        path: getPXLContactRoute(),
        component: Contact,
        type: 'route',
        loginRequired: true,
    },
];

export default routes;
